// assets/cpo-cart-sync.js
(function () {
  if (window.__CPO_CART_SYNC_INIT) return;
  window.__CPO_CART_SYNC_INIT = true;

  const CPOCartSync = {
    async fetchCart() {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Failed to load cart.js');
      return res.json();
    },

    groupCart(cart) {
      const map = {};
      (cart.items || []).forEach((item, idx) => {
        const props = item.properties || {};
        const gid = props._cpo_group ? String(props._cpo_group) : null;
        if (!gid) return;

        if (!map[gid]) map[gid] = { lines: [], main: [], addon: [] };

        const isAddon = props._addon_type === 'custom_options';
        const line = {
          index: idx + 1, // Shopify line index (1-based)
          id: item.id,
          quantity: item.quantity,
          props
        };

        map[gid].lines.push(line);
        (isAddon ? map[gid].addon : map[gid].main).push(line);
      });
      return map;
    },

    async removeGroupByLineIndex(targetLineIndex) {
      const cart = await this.fetchCart();
      const item = cart.items[targetLineIndex - 1];
      if (!item || !item.properties || !item.properties._cpo_group) return false;

      const groupId = item.properties._cpo_group;
      const map = this.groupCart(cart);
      const group = map[groupId];
      if (!group) return false;

      // Remove all lines in the group (descending order to avoid index shifts)
      const indices = group.lines.map(l => l.index).sort((a, b) => b - a);
      for (const line of indices) {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: 0 })
        });
        if (!res.ok) throw new Error('Failed to remove grouped line ' + line);
      }
      return true;
    },

    attachRemoveInterceptors() {
      // 1) Anchor removes (?line=X&quantity=0)
      document.addEventListener('click', async (e) => {
        const a = e.target.closest('a[href*="/cart/change"]');
        if (!a) return;

        const url = new URL(a.getAttribute('href'), window.location.origin);
        const q = url.searchParams.get('quantity');
        const lineStr = url.searchParams.get('line') || url.searchParams.get('line_number');
        if (q !== '0' || !lineStr) return;

        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        const lineIndex = parseInt(lineStr, 10);

        try {
          const handled = await CPOCartSync.removeGroupByLineIndex(lineIndex);
          if (!handled) {
            // Fallback: perform a normal remove for non-grouped lines
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: lineIndex, quantity: 0 })
            });
          }
          window.location.reload();
        } catch (err) {
          console.error('[CPO] Group remove failed (anchor):', err);
          window.location.reload();
        }
      }, true); // capture

      // 2) Dawn <cart-remove-button> and buttons with data-index/line
      document.addEventListener('click', async (e) => {
        const btn = e.target.closest('cart-remove-button,[is="cart-remove-button"],button[name="remove"],button[data-index],button[data-line]');
        if (!btn) return;

        const idxAttr = btn.dataset.index || btn.dataset.line || btn.getAttribute('data-line') || btn.getAttribute('data-index') || btn.value;
        if (!idxAttr) return;

        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        const lineIndex = parseInt(idxAttr, 10);
        if (!Number.isInteger(lineIndex) || lineIndex <= 0) return;

        try {
          const handled = await CPOCartSync.removeGroupByLineIndex(lineIndex);
          if (!handled) {
            // Fallback: normal remove for non-grouped lines
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: lineIndex, quantity: 0 })
            });
          }
          window.location.reload();
        } catch (err) {
          console.error('[CPO] Group remove failed (button):', err);
          window.location.reload();
        }
      }, true); // capture

      // 3) Forms that post to /cart/change (some Dawn variants)
      document.addEventListener('submit', async (e) => {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        const action = form.getAttribute('action') || '';
        if (!/\/cart\/change/.test(action)) return;

        const fd = new FormData(form);
        const qty = fd.get('quantity') || fd.get('change');
        const lineStr = fd.get('line') || fd.get('line_number');
        if (!(qty === '0' || qty === 0) || !lineStr) return;

        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        const lineIndex = parseInt(lineStr, 10);

        try {
          const handled = await CPOCartSync.removeGroupByLineIndex(lineIndex);
          if (!handled) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: lineIndex, quantity: 0 })
            });
          }
          window.location.reload();
        } catch (err) {
          console.error('[CPO] Group remove failed (form):', err);
          window.location.reload();
        }
      }, true); // capture
    },

    async reconcileOrphans() {
      try {
        const cart = await this.fetchCart();
        const map = this.groupCart(cart);

        const linesToRemove = [];
        Object.values(map).forEach(group => {
          const hasMain = group.main.length > 0;
          const hasAddon = group.addon.length > 0;
          if (hasMain && hasAddon) return; // pair is intact
          group.lines.forEach(l => linesToRemove.push(l.index));
        });

        if (!linesToRemove.length) return;

        linesToRemove.sort((a, b) => b - a);
        for (const line of linesToRemove) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity: 0 })
          });
        }
        window.location.reload();
      } catch (e) {
        console.warn('[CPO] Orphan reconcile failed:', e);
      }
    },

    syncing: false,

    async syncQuantities() {
      if (this.syncing) return;
      this.syncing = true;
      try {
        const cart = await this.fetchCart();
        const map = this.groupCart(cart);

        const updates = []; // array of { line, quantity }
        Object.values(map).forEach(group => {
          if (group.main.length !== 1 || group.addon.length !== 1) return; // only pairs
          const main = group.main[0];
          const addon = group.addon[0];

          const dollarsPerMain = parseInt(addon.props._total_dollars_per_main || '0', 10);
          if (!Number.isInteger(dollarsPerMain) || dollarsPerMain <= 0) return;

          const desiredAddonQty = main.quantity * dollarsPerMain;
          if (desiredAddonQty !== addon.quantity) {
            updates.push({ line: addon.index, quantity: desiredAddonQty });
          }
        });

        if (!updates.length) return;

        // Apply updates sequentially (change.js only accepts single change per call reliably)
        for (const u of updates.sort((a,b)=>a.line-b.line)) {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(u)
          });
          if (!res.ok) throw new Error('Failed to sync quantity for line ' + u.line);
          await res.json();
        }

        // Reload to reflect changes in both page and drawer
        window.location.reload();
      } catch (e) {
        console.warn('[CPO] Quantity sync failed:', e);
      } finally {
        this.syncing = false;
      }
    },

    attachDawnHooks() {
      const rebound = () => {
        // Orphan cleanup + qty sync after Dawn updates
        this.reconcileOrphans();
        this.syncQuantities();
      };

      document.addEventListener('cart:updated', rebound);
      document.addEventListener('cart:refresh', rebound);

      const drawer = document.querySelector('cart-drawer, #CartDrawer');
      if (drawer && 'MutationObserver' in window) {
        const obs = new MutationObserver(() => {
          clearTimeout(this.__debounce);
          this.__debounce = setTimeout(() => this.syncQuantities(), 150);
        });
        obs.observe(drawer, { childList: true, subtree: true });
      }
    },

    init() {
      this.attachRemoveInterceptors();
      this.attachDawnHooks();
      // Clean + sync on first load
      this.reconcileOrphans();
      this.syncQuantities();
    }

  };

  window.CPOCartSync = CPOCartSync;
  CPOCartSync.init();
})();